import './polyfills'; // Import polyfills first
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from './App';
import NoAccess from './NoAccess';
import TransStatisticsSearch from './components/TransStatisticsSearch';
import TransLogSearch from './components/TransLogSearch';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/no-access' element={<NoAccess />} />
        <Route path="/" element={<App />} >
          <Route path="/" element={<TransLogSearch />} />
          <Route path="statistics" element={<TransStatisticsSearch />} />
        </Route>
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
